import './App.css';

import {
  //   NectDefaultGlobalStyle,
  NectDefaultTheme
} from '@nect/ui/theme/nect-default';
import { useTransition } from '@react-spring/core';
import { animated } from '@react-spring/web';
import { createBrowserHistory } from 'history';
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useRef } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { initialState, routes } from './constants/constants';
import { getItem } from './helper/storage';
import { StateProvider, mainReducer } from './hooks/useState';
import { useRouter } from './react-router-hooks';
import { ErrorScreen } from './screens/ErrorScreen';
import { FaqContentScreen } from './screens/FaqContentScreen';
import { FaqScreen } from './screens/FaqScreen';
import { FaqSelectionScreen } from './screens/FaqSelectionScreen';
import { FaqStartScreen } from './screens/FaqStartScreen';
import { FaqSubCategoryScreen } from './screens/FaqSubCategoryScreen';
import { FeedbackFormScreen } from './screens/FeedbackFormScreen';
import { HelpFormScreen } from './screens/HelpFormScreen';
import { theme } from './theme';

const customHistory = createBrowserHistory();
const push = customHistory.push;

/**
 * Attach case_uuid to url search if available
 */
customHistory.push = (args: any) => {
  const redirectURL = getItem('redirect_url');
  const uuid = getItem('uuid');

  if (typeof args === 'string') {
    if (typeof uuid === 'string') {
      args = {
        pathname: args,
        search:
          typeof redirectURL === 'string'
            ? `?case_uuid=${uuid}&redirect_url=${encodeURIComponent(
                redirectURL
              )}`
            : `?case_uuid=${uuid}`
      };
    }
  } else if (typeof args === 'object') {
    if (typeof uuid === 'string' && !args.search) {
      args.search =
        typeof redirectURL === 'string'
          ? `?case_uuid=${uuid}&redirect_url=${encodeURIComponent(redirectURL)}`
          : `?case_uuid=${uuid}`;
    }
  }

  push(args);
};

const Wrapper = ({ children }: any): any => {
  const { location } = useRouter();

  const transitions = useTransition(location, location => location.pathname, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 }
  });

  const ref: any = useRef(false);

  return transitions.map(({ item, props, key }) => (
    <animated.div
      ref={ref}
      key={key}
    >
      <Switch location={item}>{children}</Switch>
    </animated.div>
  ));
};

export const App = () => {
  return (
    <ThemeProvider theme={{ ...theme, ...NectDefaultTheme }}>
      {/* <NectDefaultGlobalStyle /> */}
      <Router history={customHistory}>
        <StateProvider initialState={initialState} reducer={mainReducer}>
          <Wrapper>
            <Route exact path={routes.HOME} component={FaqStartScreen} />
            <Route
              exact
              path={routes.FAQSELECTION}
              component={FaqSelectionScreen}
            />
            <Route exact path={routes.FAQ} component={FaqScreen} />
            <Route
              exact
              path={routes.FAQSUBCATEGORY}
              component={FaqSubCategoryScreen}
            />
            <Route
              exact
              path={routes.FAQCONTENT}
              component={FaqContentScreen}
            />
            <Route exact path={routes.HELPFORM} component={HelpFormScreen} />
            <Route
              exact
              path={routes.FEEDBACKFORM}
              component={FeedbackFormScreen}
            />
            <Route component={ErrorScreen} /* '404' route */ />
          </Wrapper>
        </StateProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
